import { StockTypeEnum } from 'app/modules/inventory/items/core/enum';

import isNil from 'lodash/isNil';

export const hasWhiteSpace = (str: string) => {
  const trimmedStr = str.trim();

  const regex = /\s/;

  return regex.test(trimmedStr);
};

export const getDefaultStockLevelPercentage = (stockLevelSettings: any[], stockType: string) => {
  const stockTypeValue =
    stockType === 'Chargeable' ? StockTypeEnum.Chargeable : StockTypeEnum['Non-Chargeable'];
  const stockTypeKey = stockTypeValue === StockTypeEnum.Chargeable ? 'chargeable' : 'nonChargeable';

  const defaultAlarmSetting = stockLevelSettings.find(
    (setting) =>
      setting.type === 'stock_level' && setting.name === 'alarm' && isNil(setting.organization),
  );

  const defaultRestockSetting = stockLevelSettings.find(
    (setting) =>
      setting.type === 'stock_level' && setting.name === 'restock' && isNil(setting.organization),
  );

  const defaultAlarmPercentage = defaultAlarmSetting?.value?.[stockTypeKey] || 20;
  const defaultRestockPercentage = defaultRestockSetting?.value?.[stockTypeKey] || 40;

  return {
    alarmPercentage: defaultAlarmPercentage / 100,
    restockPercentage: defaultRestockPercentage / 100,
  };
};
